import { render, staticRenderFns } from "./userDashboardCustomerInfos.vue?vue&type=template&id=d40e4856&scoped=true"
import script from "./userDashboardCustomerInfos.vue?vue&type=script&lang=js"
export * from "./userDashboardCustomerInfos.vue?vue&type=script&lang=js"
import style0 from "./userDashboardCustomerInfos.vue?vue&type=style&index=0&id=d40e4856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40e4856",
  null
  
)

export default component.exports